import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import { AppButton } from "../Generic/AppButton";
import { AppOverlay } from "../Generic/AppOverlay";

interface Props {
  isOpen: boolean;
  pendingTasksAmount: number;
  onClickReviewTasks: () => void;
  onRequestClose: () => void;
}

export const PendingPatientTasksBottomSheet = (props: Props) => {
  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={props.isOpen}
        rounded={true}
        onRequestClose={props.onRequestClose}
        className="PendingPatientTasksBottomSheet__container"
      >
        <div className="PendingPatientTasksBottomSheet">
          <img src="assets/pending-tasks-to-schedule.svg" alt="pending-tasks" />
          <div className="titles">
            <span className="title">
              {props.pendingTasksAmount}{" "}
              {props.pendingTasksAmount === 1
                ? translate(STRINGS.NEW_TASK)
                : translate(STRINGS.NEW_TASKS)}
            </span>
            <span>{translate(STRINGS.WAITING_TO_BE_SCHEDULED)}</span>
          </div>
          <div className="actions">
            <AppButton
              color="primary"
              variant="filled"
              size="small"
              textColor="white"
              onClick={props.onClickReviewTasks}
            >
              {translate(STRINGS.REVIEW_TASKS)}
            </AppButton>
            <AppButton
              color="primary"
              variant="outline"
              size="small"
              textColor="primary"
              onClick={props.onRequestClose}
            >
              {translate(STRINGS.REMIND_ME_LATER)}
            </AppButton>
          </div>
        </div>
      </AppBottomSheet>
    </AppOverlay>
  );
};
